import React from "react";
//Limitless imports
import { TUTORIAL_JSON, fetchPlatformResources } from "@limitless/common/apis/resource-api";
import { log as pilog } from "@limitless/common/utils";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
const INITIAL_STATE = {
  loading: false,
  data: {}
};
export const useExpertTutorialsHook = () => {
  const [tutorials, setTutorials] = React.useState(INITIAL_STATE);
  const {
    profile
  } = useExpertProfileContext();
  React.useEffect(() => {
    if (!profile.loading) {
      fetchTenantTutorials();
    }
  }, [profile.loading]);
  const fetchTenantTutorials = (useDefaultLocale = false) => {
    setTutorials({
      loading: true,
      data: {}
    });
    const log = pilog.getLogger("TenantTutorialResourceAction fetchTenantTutorials");
    log.debug("Fetching Tutorial Resource");
    const updatedtutorialResource = {};
    let locale = `${profile.language}-${profile.country}`;
    if (useDefaultLocale) {
      locale = "en-GB";
    }
    fetchPlatformResources({
      resourceList: [TUTORIAL_JSON],
      locale
    }, resource => {
      log.debug("Resource found ", resource);
      try {
        if (resource && resource.length !== 0 && resource[0].content) {
          try {
            const tutorialResource = resource[0].content;
            const {
              groups
            } = profile;
            Object.keys(tutorialResource).map(key => {
              if (key === "tenants") {
                Object.keys(tutorialResource[key]).map(tenantKey => {
                  groups.map(groupItem => {
                    if (tenantKey === groupItem.tenantName) {
                      updatedtutorialResource[tenantKey] = tutorialResource[key][tenantKey];
                    }
                  });
                });
              } else {
                if (key === "Tutorials") {
                  updatedtutorialResource["Limitless Tutorials"] = tutorialResource[key];
                } else {
                  updatedtutorialResource[key] = tutorialResource[key];
                }
              }
            });
            setTutorials({
              loading: false,
              data: {
                ...tutorials.data,
                ...updatedtutorialResource
              }
            });
          } catch (error) {
            setTutorials({
              loading: false,
              data: {}
            });
            log.error(`Invalid JSON for ${TUTORIAL_JSON.name}, default resource will be used`, error);
          }
        } else {
          setTutorials({
            loading: false,
            data: {}
          });
          if (!useDefaultLocale) {
            fetchTenantTutorials(profile, true);
          }
        }
      } catch (error) {
        setTutorials({
          loading: false,
          data: {}
        });
        log.error(`Error processing platform resources ${TUTORIAL_JSON.name}, defaults will be used`);
      }
    });
  };
  return {
    tutorials
  };
};